export const CREATE_DEPOSITE_SUCCESS ="CREATE_DEPOSITE_SUCCESS"
export const CREATE_DEPOSIT_FAIL     ="CREATE_DEPOSIT_FAIL"
export const SHOW_DEPOSITE_SUCCESS   ="SHOW_DEPOSITE_SUCCESS"
export const SHOW_DEPOSIT_FAIL       ="SHOW_DEPOSIT_FAIL"
export const UPDATE_DEPOSIT_SUCCESS  ="UPDATE_DEPOSIT_SUCCESS"
export const UPDATE_DEPOSIT_FAIL     ="UPDATE_DEPOSIT_FAIL"
export const DELETE_DEPOSIT_SUCCESS  ="DELETE_DEPOSIT_SUCCESS"
export const DELETE_DEPOSIT_FAIL     ="DELETE_DEPOSIT_FAIL"